import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import PricingCards from './PricingCards';
import SafeIcon from '../common/SafeIcon';
import { FiHeart, FiChevronDown } from 'react-icons/fi';

const SponsorSection = ({ language }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const sectionRef = useRef(null);
  
  // Update the data-expanded attribute when the state changes
  useEffect(() => {
    if (sectionRef.current) {
      sectionRef.current.setAttribute('data-expanded', isExpanded.toString());
    }
  }, [isExpanded]);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <motion.div 
      id="sponsor-section"
      ref={sectionRef}
      data-expanded={isExpanded.toString()}
      className="bg-gradient-to-br from-love-50 to-secondary-50 dark:from-gray-800 dark:to-gray-850 rounded-xl shadow-md overflow-hidden mb-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.6 }}
    >
      <motion.button
        className="w-full flex items-center justify-between p-6 cursor-pointer group"
        onClick={toggleExpand}
        whileTap={{ scale: 0.98 }}
        aria-expanded={isExpanded}
        aria-controls="sponsor-content"
      >
        <div className="flex items-center">
          <SafeIcon 
            icon={FiHeart} 
            className="text-love-500 mr-3 text-2xl group-hover:animate-heartbeat" 
          />
          <div className="text-left">
            <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200">
              {language === 'zh' ? '💖 支持寵物紀念日' : '💖 Support Pet Days'}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              {language === 'zh' 
                ? '您的贊助讓我們能夠持續改進和添加新功能'
                : 'Your sponsorship helps us continue improving and adding new features'
              }
            </p>
          </div>
        </div>
        
        <motion.div
          animate={{ rotate: isExpanded ? 180 : 0 }}
          transition={{ duration: 0.3 }}
          className="text-gray-500 dark:text-gray-400 group-hover:text-love-500 dark:group-hover:text-love-400 transition-colors"
        >
          <SafeIcon icon={FiChevronDown} className="text-xl" />
        </motion.div>
      </motion.button>

      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            id="sponsor-content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div className="p-6 pt-0 border-t border-love-100 dark:border-love-900">
              <PricingCards language={language} />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default SponsorSection;